import(/* webpackMode: "eager" */ "/Users/dappweb/Documents/GitHub/Azuro-protocol/example-app/src/app/liquidity/page.tsx");
